import { Box, Switch, Typography } from '@material-ui/core';
import React from 'react';
import { useCampfireLazyQuery } from '../../../../../global/network/useCampfireLazyQuery';
import { useSnackbar } from '../../../../../global/config/useSnackbar';
import { useCampfireFetch } from '../../../../../global/network/useCampfireFetch';
import { useApiUrl } from '../../../../../global/config/useApiUrl';
import { GET_CONFIG_ITEM } from './config-item.gql';
import { GetConfigItem } from './__generated__/GetConfigItem';

export function PreventVolunteerReports() {
  const [queryPreventVolunteerReports] = useCampfireLazyQuery<GetConfigItem, { key: string }>(GET_CONFIG_ITEM);
  const [preventVolunteerReports, setPreventVolunteerReports] = React.useState<boolean | undefined>();
  const { setSnackbar } = useSnackbar();

  React.useEffect(() => {
    queryPreventVolunteerReports({ variables: { key: 'prevent-volunteer-reports' } }).then((response) =>
      setPreventVolunteerReports(
        response.data?.vm.configItem?.defaultValue || response.data?.vm.configItem?.configItemValue?.flagValue
      )
    );
  }, []);

  const savePreventVolunteerReports = useCampfireFetch({ defer: true });

  const apiUrl = useApiUrl();
  const onSave = () => {
    savePreventVolunteerReports
      .run({
        url: `${apiUrl}/vm/admin-console/operations/config-item`,
        method: 'post',
        data: {
          key: 'prevent-volunteer-reports',
          value: !preventVolunteerReports,
        },
      })
      .then(() => {
        setSnackbar({
          open: true,
          message: 'Successfully updated',
          variant: 'success',
        });
      });
    setPreventVolunteerReports(!preventVolunteerReports);
  };

  return (
    <Box mt={2}>
      <Box display='flex' alignItems={'center'}>
        <Switch
          checked={Boolean(preventVolunteerReports)}
          onChange={onSave}
          color='primary'
          inputProps={{ 'aria-label': 'prevent volunteer reports' }}
        />
        <Box ml={1}>
          <Typography
            style={{
              fontWeight: 500,
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            Prevent Volunteer Reports
          </Typography>
          <Typography variant={'body2'} style={{ fontSize: '13px', color: '#808080' }}>
            {
              'Hide activity reports section from general volunteers. Activity Leaders, Program Managers, and Admins will be able to view and manage reports as normal.'
            }
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
